import { RM3_BOARD } from 'arbitrip-common/client/utils/HotelDealsRm3';

// Today's board labels (`DealComponent.getAmenities`), plus the room-only line the RM3 design adds.
// Shared by the deal row and the board filter chips so the two can never drift.
export const BOARD_LABEL_KEYS = Object.freeze({
    [RM3_BOARD.ALL_INCLUSIVE]: 'CateringAllInclusive',
    [RM3_BOARD.FULL_BOARD]: 'CateringFullBoard',
    [RM3_BOARD.HALF_BOARD]: 'CateringHalfBoard',
    [RM3_BOARD.BREAKFAST]: 'BreakfastIncluded',
    [RM3_BOARD.ROOM_ONLY]: 'HotelDealsRm3.BoardRoomOnly',
});
